'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IntentsToPath;

var _AllowedIntents = require('./AllowedIntents');

var _AllowedIntents2 = _interopRequireDefault(_AllowedIntents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IntentsToPath = (_IntentsToPath = {}, _defineProperty(_IntentsToPath, _AllowedIntents2.default.LEAD_FLOWS, 'lead-flows'), _defineProperty(_IntentsToPath, _AllowedIntents2.default.MEETINGS, 'salesMeetings'), _defineProperty(_IntentsToPath, _AllowedIntents2.default.CONVERSATIONS, 'conversations'), _defineProperty(_IntentsToPath, _AllowedIntents2.default.DOCUMENTS, 'salesDocuments'), _defineProperty(_IntentsToPath, _AllowedIntents2.default.FORMS, 'marketingFreeForms'), _IntentsToPath);

exports.default = IntentsToPath;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.35/js/constants/IntentsToPath.js
// module id = 1061
// module chunks = 2 3